import { Clock, Sunrise, TimerReset } from "lucide-react";

function fmtDur(secs) {
  if (secs == null) return "—";
  const d = Math.floor(secs / 86400);
  const h = Math.floor((secs % 86400) / 3600);
  const m = Math.floor((secs % 3600) / 60);
  const s = secs % 60;
  if (d > 0) return `${d}d ${h}h ${m}m`;
  if (h > 0) return `${h}h ${m}m ${s}s`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
}

export function MarketClock({ market }) {
  if (!market) return null;
  const open = market.is_open;

  let icon, label, value, tone;
  if (open) {
    icon = <TimerReset size={14} />;
    label = "Square-off in";
    value = fmtDur(market.seconds_to_squareoff);
    tone = "#00E676";
  } else {
    icon = <Sunrise size={14} />;
    label = market.status === "PRE_OPEN" ? "Opens in" : "Next open in";
    value = fmtDur(market.seconds_to_open);
    tone = "#FFB300";
  }

  return (
    <div className="mx-4 mt-3 flex items-center justify-between bg-surface border border-edge rounded-sm px-3 py-2" data-testid="market-clock">
      <div className="flex items-center gap-2 text-muted2">
        <Clock size={14} />
        <span className="mono text-[11px]">IST {market.ist_time}</span>
      </div>
      <div className="flex items-center gap-1.5" style={{ color: tone }}>
        {icon}
        <span className="text-[10px] uppercase tracking-wider text-muted2">{label}</span>
        <span className="mono text-xs font-bold" style={{ color: tone }} data-testid="market-countdown">{value}</span>
      </div>
    </div>
  );
}
